import type { GUID } from "../types/GUID"

export function GUIDToUint8(guid: GUID): Uint8Array {
  const result = new Uint8Array(32)
  let value: bigint = guid
  for (let i = 31; i >= 0; i--) {
    result[i] = Number(value & 0xffn)
    value >>= 8n
  }
  return result
}
